import Breadcumb from '../../components/Breadcumb'
import NewNFTs from "../../components/NewNFTs"
import MsgAlert from "../../components/MsgAlert"
import {iconsNote} from "../../utils/allImgs"
import data from '../../data/data-containers/data-Explore'
import SEO from "../../components/Seo"

const ExploreNFTsContainer = () => {

  return (
    <>
      <SEO title="Explore" />
      <main>
        <Breadcumb title='Explore NFTs' />
        <NewNFTs data={data[0].NewNFTs} />
        <MsgAlert
          img={iconsNote}
          title="No Items Listed For Sale Yet!"
          text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga similique accusantium quae natus odio est ullam ab. Ea iusto corrupti.!"
        />
      </main>
    </>
  );
}

export default ExploreNFTsContainer;